import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button } from "antd";
import {
  ColumnHeightOutlined,
  DeleteOutlined,
  LeftOutlined,
  VerticalAlignMiddleOutlined,
} from "@ant-design/icons";
import { ColumnsSettings } from "src/components/tables/ColumnsSettings";
import { ModalDelete } from "src/components/ModalDelete";
import { StateView } from "src/components/StateView";
import styles from "./Bom3Positions.module.less";
import { Bom3PositionStore } from "./Bom3PositionsStore";
import { Bom3PositionsTableBox } from "./Bom3PositionsTableBox";

type PropsBom3Positions = {
  store: Bom3PositionStore;
  onExit: () => void;
};

export const Bom3Positions: React.FC<PropsBom3Positions> = observer((props) => {
  const { store, onExit } = props;
  const { bom } = store;
  return (
    <div className={styles.box}>
      <div className={styles.head}>
        <div className={styles.left}>
          <Button icon={<LeftOutlined />} onClick={onExit} />
          <div className={styles.name}>{bom.name}</div>
          {!!bom.state && <StateView name={bom.state.name} />}
        </div>
        <div className={styles.right}>
          <Button
            size="small"
            icon={<VerticalAlignMiddleOutlined />}
            title="Collapse all materials"
            onClick={() => store.collapseAll()}
            disabled={!store.canCollapseAll}
          />
          <Button
            size="small"
            icon={<ColumnHeightOutlined />}
            title="Expand all materials"
            onClick={() => store.expandAll()}
            disabled={!store.canExpandAll}
          />
          <ColumnsSettings store={store.ctrlColumns} freezeLine />
          {store.possibleDelete && (
            <Button
              icon={<DeleteOutlined />}
              disabled={!store.canDelete}
              onClick={() => {
                store.setDeleteConfirm(true);
              }}
              title={`Selected count = ${store.selectedRows.size}`}
            >
              Удалить
            </Button>
          )}
        </div>
      </div>
      <Bom3PositionsTableBox store={store} />
      <ModalDelete
        open={store.deleteConfirm}
        message="Удалить выбранное?"
        waiting={store.buzy}
        onOk={() => store.deleteSelectedRows()}
        onCancel={() => store.setDeleteConfirm(false)}
      />
    </div>
  );
});
